export default __webpack_public_path__ + "static/media/Group 3364.6be517f7.png";